import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Accordion } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { useAuth } from '../../contexts/AuthContext';
import { getVisibleMenuItems, splitMenuItems, getMenuLabel, getMenuIcon } from './menuGroups';
import './sidebar.scss';

function Sidebar({ open, onClose }) {
    const { loginState, menuItems } = useAuth();

    useEffect(() => {
        if (!open) return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [open, onClose]);

    const visibleItems = getVisibleMenuItems(menuItems, loginState);
    const { groups } = splitMenuItems(visibleItems);

    return (
        <>
            <div
                className={`sidebar-backdrop ${open ? 'open' : ''}`}
                onClick={onClose}
                aria-hidden="true"
            />
            <aside className={`app-sidebar ${open ? 'open' : ''}`}>
                <div className="app-sidebar-header">
                    <span>Menü</span>
                    <button className="app-sidebar-close" onClick={onClose} aria-label="Bezárás">
                        <X size={22} />
                    </button>
                </div>
                <Accordion alwaysOpen className="app-sidebar-groups">
                    {groups.map((group, index) => (
                        <Accordion.Item eventKey={String(index)} key={group.key}>
                            <Accordion.Header>
                                <span className="app-sidebar-group-icon">{getMenuIcon(group.icon, 18)}</span>
                                {group.label}
                            </Accordion.Header>
                            <Accordion.Body>
                                <ul className="app-sidebar-items">
                                    {group.items.map((item) => (
                                        <li key={item.ID || item.MenuPath}>
                                            <NavLink to={item.MenuPath} onClick={onClose}>
                                                <span className="app-sidebar-item-icon">
                                                    {getMenuIcon(item.MenuIcon, 18)}
                                                </span>
                                                {getMenuLabel(item)}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </aside>
        </>
    );
}

export default Sidebar;
